import {
  LayoutDashboard,
  Users,
  Package,
  ClipboardList,
  Warehouse,
  ShoppingCart,
  Truck,
  FileText,
  FileCheck2,
  BarChart3,
  UserCog,
  type LucideIcon,
} from "lucide-react";
import type { Dictionary } from "../i18n/translations";
import type { AppEnvironment } from "./environment";

export interface NavItem {
  key: keyof Dictionary["nav"];
  path: string;
  icon: LucideIcon;
  testId: string;
  permissions: string[];
  previewAvailable?: boolean;
  previewOnly?: boolean;
}

export interface NavGroup {
  key: keyof Dictionary["nav"];
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    key: "section_pilotage",
    items: [
      { key: "preview", path: "/", icon: Package, testId: "sidebar-preview-link", permissions: ["catalogue.resolve"], previewAvailable: true, previewOnly: true },
      { key: "dashboard", path: "/", icon: LayoutDashboard, testId: "sidebar-dashboard-link", permissions: ["dashboard.read"] },
      { key: "statistiques", path: "/statistiques", icon: BarChart3, testId: "sidebar-statistiques-link", permissions: ["dashboard.read"] },
    ],
  },
  {
    key: "section_ventes",
    items: [
      { key: "clients", path: "/clients", icon: Users, testId: "sidebar-clients-link", permissions: ["crm.read"] },
      { key: "produits", path: "/produits", icon: Package, testId: "sidebar-produits-link", permissions: ["catalogue.physical.read", "catalogue.procurement.read", "catalogue.sales.read"] },
      { key: "commandes", path: "/commandes", icon: ClipboardList, testId: "sidebar-commandes-link", permissions: ["orders.read"] },
      { key: "facturation", path: "/facturation", icon: FileText, testId: "sidebar-facturation-link", permissions: ["billing.read"] },
    ],
  },
  {
    key: "section_logistique",
    items: [
      { key: "inventaire", path: "/inventaire", icon: Warehouse, testId: "sidebar-inventaire-link", permissions: ["catalogue.physical.read"] },
      { key: "achats", path: "/achats", icon: ShoppingCart, testId: "sidebar-achats-link", permissions: ["procurement.read"] },
      { key: "expedition", path: "/expedition", icon: Truck, testId: "sidebar-expedition-link", permissions: ["preparations.read", "shipments.read"] },
      { key: "livraisons", path: "/livraisons", icon: FileCheck2, testId: "sidebar-livraisons-link", permissions: ["deliveries.proof.read"] },
    ],
  },
  {
    key: "section_administration",
    items: [
      { key: "utilisateurs", path: "/utilisateurs", icon: UserCog, testId: "sidebar-utilisateurs-link", permissions: ["audit.read.all"] },
    ],
  },
];

export function navigationGroupsForEnvironment(
  environment: AppEnvironment,
): NavGroup[] {
  return NAV_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) =>
      environment === "staging"
        ? item.previewAvailable === true
        : item.previewOnly !== true,
    ),
  })).filter((group) => group.items.length > 0);
}
